import { captureRemixErrorBoundaryError } from "@sentry/remix";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError
} from "@remix-run/react";

// import {Banner} from '@shopify/polaris';

export const ErrorBoundary = () => {
  const error = useRouteError();
  captureRemixErrorBoundaryError(error);
  return (
    <div style={{backgroundColor: "#fff", display: "inline-block", padding: "0.5rem 1rem", borderRadius: "0.5rem", fontFamily: 'Sans-serif', margin: "1rem"}}>
      <h3>
        Something went wrong.
      </h3>
      <p>
        It's probably our fault, but if you want to try to figure it out yourself, check out our <a href="https://uneven-swoop-baa.notion.site/GiftCardReminders-Help-Center-aec3a3f4718749b2b1a0ac46d1b82cc1">Help center and FAQs</a>.
      </p>
      <p>
        If the issue is serious, please <a href="mailto:simon@giftcardreminders.com">email support</a>.
      </p>
    </div>
    );
};

export default function App() {
  return (
    <html>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="preconnect" href="https://cdn.shopify.com/" />
        <link
          rel="stylesheet"
          href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
        />
        <link
          rel="preload"
          href="https://imagedelivery.net/irgwRnbOZcxOVUqt_TeUBA/33071a0e-07fd-40c9-a0f4-8ea2ac7f4400/public"
          as="image"
        />
        <Meta />
        <Links />
      </head>
      <body>
        <Outlet />
        <ScrollRestoration />
        <Scripts />
        <script src="https://cdn.shopify.com/shopifycloud/polaris.js"></script>
      </body>
    </html>
  );
}
